import template from './requestFormTitle.html';
import controller from './requestFormTitle.controller';

let requestFormTitleComponent = {
  restrict: 'E',
  bindings: {
    isEdit: '<',
    isEditSickness: '<',
    isVacation: '<',
    isAbsence: '<',
    isHourly: '<',
    initialRequestCategory: '<'
  },
  template,
  controller
};

export default requestFormTitleComponent;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/modals/modalRequest/requestForm/requestFormTitle/requestFormTitle.component.js